import apiCall, { maybeSetToken } from "../axios";

const tokenCheck = async (token = null, uuid = null) => {
  try {
    maybeSetToken(token);
    const res = await apiCall("GET", uuid ? `user?uuid=${uuid}` : `user`);
    console.log('res', res);
    return res.data;
  } catch (e) {
    // remove token from local storage
    maybeSetToken(null);
    localStorage.removeItem("@BLUE-id_token");
    localStorage.removeItem("@BLUE-expires_at");
    localStorage.removeItem("@BLUE-user");
    return { error: "Expired token" };
  }
};
export default tokenCheck;